import React from 'react';
import { useState, useEffect } from 'react';
import { FaTicketAlt, FaCheckCircle } from 'react-icons/fa';
import { FaTimes } from 'react-icons/fa'; // For the close icon
import { FaSearch } from "react-icons/fa";
import Navbar from '../../components/common/Navabar';
import busmain from "../../asserst/websiteImage/busmain.png";
import urbiana from "../../asserst/websiteImage/urbiana.png";
import busBlue from "../../asserst/websiteImage/busleft.png";
import innova from "../../asserst/websiteImage/innova.png";

import busWhite from "../../asserst/websiteImage/busright.png";
import countImage from "../../asserst/websiteImage/countImage.png";
import whitebg from "../../asserst/websiteImage/whitebg.png";
import { motion } from 'framer-motion';
import Footer from '../../components/common/Footer';
import InquiryForm from '../../components/common/Homepage_Form';
import { Link } from 'react-router-dom';

const Homepage = () => {

    const [showInquiryForm, setShowInquiryForm] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const testimonials = [
        {
            title:"Exceptional Service!",
            review: `Booking a ride was so easy, and the driver was punctual and professional. The car was clean, and the journey was incredibly smooth. Highly recommend their service!`,
            name: "— Amit Sharma",
        },
        {
            title:"Stress-Free Travel Experience!",
            review: `I’ve used their service multiple times, and they never disappoint. From easy booking to safe travel, everything is seamless. A truly reliable travel partner`,
            name: "— Priya Desai",
        },
        {
            title:"Great Customer Support!",
            review: `Their support team was so helpful when I had to make a last-minute change to my booking. Truly customer-focused and efficient service`, name: "— Rahul Mehta"
        },
        {
            title:"Safe and Comfortable Rides!",
            review: `Safety was my top concern, and they delivered on every promise. The driver was professional, and I felt completely at ease during the trip.`,
            name: "— Sneha Kapoor"
        }]

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
        }, 2000);

        return () => clearInterval(timer);
    }, []);


    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    };

    const {title, review, name } = testimonials[currentIndex];
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowInquiryForm(true);
        }, 1000)
        return () => clearTimeout(timer);
    }, [])

    const closeInquiryForm = () => {
        setShowInquiryForm(false);
    };

    const openInquiryForm = () => {
        setShowInquiryForm(true);
    }
    const steps = [
        {
            step: "Step 1",
            description: "Search and select your ticket to find the best match for your travel needs.",
            color: "bg-purple-600",
            icon: <FaSearch className="text-white h-12 w-12" />, // Icon with white color for visibility
        },
        {
            step: "Step 2",
            description: "Book your ticket easily and securely, locking in your preferred schedule and options.",
            color: "bg-red-400",
            icon: <FaTicketAlt className="text-white h-12 w-12" />,
        },
        {
            step: "Step 3",
            description: "Confirm your booking and enjoy a seamless travel experience with Urbaiana.",
            color: "bg-blue-500",
            icon: <FaCheckCircle className="text-white h-12 w-12" />,
        },
    ];

    const countData = [
        {
            title: "Rides Completed",
            count: "100+",
            color: "bg-purple-600",
        },
        {
            title: "Happy Customers",
            count: "100+",
            color: "bg-purple-600",

        },
        {
            title: "Trusted Partners",
            count: "100+",
            color: "bg-purple-600",
        }
    ];

    return (
        <>
            <div className="">
                <Navbar />

                {/* Main Hero Section */}
                <motion.section
                    className="relative md:h-[85vh] xsm:h-[40vh] rounded-b-[30px] overflow-hidden"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.5 }}
                >
                    <img src={busmain} className="h-full w-full object-cover" alt="Main Bus" />

                    {/* Overlay container */}
                    <div className="absolute inset-0 bg-[#0739564D] flex items-center justify-center">
                        <div className="w-full xsm:w-[90%] md:max-w-[75%] h-auto flex flex-col items-center space-y-8 text-center">
                            <h1 className='text-white font-bold xsm:text-[1.5rem] md:text-[3.1rem] md:leading-[3.75rem]'> Qbus Rentals </h1>
                            <h1 className="text-white font-bold xsm:text-[1rem] md:text-[2rem] md:leading-[2.75rem]">
                                Hassle Free Quick Quote and Booking with Safe and Reliable Journey
                            </h1>
                            <button
                                onClick={openInquiryForm}
                                className="text-white bg-newGreen-50 rounded-lg xsm:px-4 xsm:py-2 md:px-8 md:py-4">
                                Enquiry Now
                            </button>
                        </div>
                    </div>
                </motion.section>

                {/* <div className="w-full relative">
                    <div
                        style={{
                            backdropFilter: 'blur(100px)',
                            width: '419px',
                            height: '419px',
                            top: '-130px',
                            left: '-210px',
                            opacity: '0.8',
                        }}
                        className="absolute -z-10 rounded-r-full  rounded-b-full  bg-gradient-to-l from-slate-50 to-indigo-100"
                    ></div>
                    <motion.section
                        className="py-16 xsm:w-[90%] sm:w-[90%] md:w-[80%] lg:w-[70%] mx-auto"
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ duration: 0.5 }}
                    >
                        <div className="mb-12 text-center">
                            <h2 className="text-3xl font-bold">Follow 3 Steps To</h2>
                            <h2 className="text-3xl font-bold">Get Your Online Booking</h2>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 gap-8">
                            {steps.map((step, index) => (
                                <motion.div
                                    key={index}
                                    className={`p-6 rounded-lg col-span-1 ${step.color} text-white`}
                                    initial={{ opacity: 0, x: -100 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.8, delay: index * 0.2 }}
                                >
                                    <div className="w-15 h-13  rounded-full mb-4 flex items-start justify-center">
                                        <div className="flex justify-center mb-4">{step.icon}</div>
                                    </div>
                                    <h3 className="font-semibold text-lg mb-2 text-center">{step.step}</h3>
                                    <p className="text-sm">{step.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </motion.section>
                </div> */}
                {/* Blue Bus */}
                <motion.section
                    className="md:py-20 xsm:py-5 w-full flex md:flex-row xsm:flex-col sm:flex md:justify-between xsm:justify-center overflow-hidden xsm:space-y-10 md:space-x-6 relative"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                >
                    <div
                        style={{
                            backdropFilter: 'blur(100px)',
                            width: '419px',
                            height: '419px',
                            bottom: '-130px',
                            right: '-210px',
                            opacity: '0.8',
                        }}
                        className="absolute overflow-hidden md:w-[419px] sxm:w-[200px] md:h-[420px] xsm:w-[200px] -z-10 rounded-r-full rounded-b-full rounded-t-full bg-gradient-to-l from-blue-50 via-white to-blue-50"
                    ></div>
                    {/* Blue Bus Image with Animation */}
                    <motion.img
                        src={urbiana}
                        alt="Blue Bus"
                        className="md:w-[50%] sm:[80%] xsm:w-[90%] xsm:mx-auto "
                        initial={{ opacity: 0, x: -200 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, delay: 0.2, type: 'spring', stiffness: 120 }}
                    />

                    <div className='md:w-[50%] xsm:w-[80%] lg:w-[45%]   xsm:mx-auto md:float-right'>
                        <motion.div
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                            className="md:w-[100%] w-[90%]  h-[80%] flex-col space-y-6 flex"
                        >
                            <h2 className="xsm:text-[1.8rem] md:text-[2.5rem] md:leading-[60px] font-semibold">
                                Enjoy Your Summer Trip With Us!
                            </h2>
                            <p className="leading-[24px] text-[1rem] text-[#6A757D]">
                                Experience seamless travel this summer with our reliable car booking service. Whether it’s a weekend getaway, a long road trip, or a quick city ride, we’ve got you covered with comfortable cars, professional drivers, and easy booking options.
                            </p>
                            <p className="text-gray-600 leading-relaxed">
                                Sit back, relax, and let us make your summer journeys unforgettable. Book your ride now and travel with confidence!
                            </p>

                            <Link to="/service">

                                <button className="bg-[#0E6c6F] w-fit text-white py-2 px-4 rounded-sm mt-4">Find out more</button>
                            </Link>
                        </motion.div>
                    </div>
                </motion.section>
                <motion.section
                    className="py-10 sm:py-16 md:py-20 lg:py-24 rounded-lg"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                >
                    <div className="flex flex-col-reverse md:flex-row justify-between w-full space-y-10 md:space-y-0">
                        {/* Left Content Section */}
                        <div className="space-y-6 w-full md:w-[50%] lg:w-[45%] xsm:mx-auto px-4 sm:px-8 md:pl-16 lg:pl-20">
                            {/* Heading */}
                            <div>
                                <motion.h3
                                    className="font-poppins text-[1.8rem] sm:text-[2rem] md:text-[2.5rem] font-medium leading-tight text-left"
                                    initial={{ opacity: 0, y: -20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.2 }}
                                >
                                    Why You Choose Us for Your Tours
                                </motion.h3>
                                <motion.p
                                    className="text-[#6A757D] font-inter text-sm sm:text-base leading-6 mt-2 text-left"
                                    initial={{ opacity: 0, x: -20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.5, delay: 0.4 }}
                                >
                                    Your journey deserves the best, and we’re here to deliver it. With seamless booking, secure travel, and exceptional service, we ensure every trip is stress-free and enjoyable.
                                </motion.p>
                            </div>

                            {/* Features List */}
                            <div className="space-y-6 pl-5">
                                {[
                                    {
                                        title: "Find Your Ticket",
                                        description: "Easily book your ride with our intuitive platform. Whether it’s a last-minute trip or a planned journey, securing your ticket is quick, simple, and hassle-free.",
                                    },
                                    {
                                        title: "Easy Payment Process",
                                        description: "Enjoy smooth and secure transactions with our multiple payment options. Focus on your adventure while we handle the rest with transparency and ease.",
                                    },
                                    {
                                        title: "Trusted Partner Services",
                                        description: "We collaborate with reliable partners to guarantee top-quality service, ensuring your travel experience is professional, efficient, and worry-free.",
                                    },
                                    {
                                        title: "Safe Transport Guarantee",
                                        description: "Your safety comes first. With well-maintained vehicles and experienced drivers, we promise a secure and comfortable journey every time.",
                                    },
                                ].map((feature, index) => (
                                    <motion.div
                                        key={index}
                                        initial={{ opacity: 0, x: -50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.5, delay: 0.2 * (index + 1) }}
                                    >
                                        <h4 className="font-poppins text-[1.5rem] font-semibold text-left">
                                            {feature.title}
                                        </h4>
                                        <p className="text-[#6A757D] text-sm sm:text-base">{feature.description}</p>
                                    </motion.div>
                                ))}
                                <p className="text-[#6A757D] text-sm sm:text-base">Let’s turn your trips into unforgettable memories—book your ride with us today!</p>
                            </div>

                            {/* Call-to-Action Button */}
                            <Link to="/service">

                                <motion.button
                                    className="bg-[#0E6c6F] w-fit text-white py-2 px-6 "
                                    initial={{ opacity: 0, scale: 0.8 }}
                                    whileInView={{ opacity: 1, scale: 1 }}
                                    transition={{ duration: 0.5, delay: 0.2 }}
                                >
                                    Find out more
                                </motion.button>
                            </Link>
                        </div>

                        {/* Right Image Section */}
                        <motion.div
                            className="flex lg:justify-end justify-end  items-center w-full md:w-[50%] float-right"
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                        >
                            <img
                                src={innova}
                                alt="White Bus"
                                className="w-[100%] sm:w-[100%] md:w-full lg:max-w-[100%] xsm:h-[250px] sm:h-[300px] md:h-[400px] object-contain"
                            />
                        </motion.div>
                    </div>
                </motion.section>
                {/* Count Section */}
                <motion.section
                    className="md:h-[70vh] xsm:h-auto xsm:pb-5  bg-cover bg-center"
                    style={{ backgroundImage: `url(${countImage})` }}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.3 }} // Delay for count section
                >
                    <div className="flex items-center justify-center w-full h-full">
                        <div className="w-full max-w-[70%] h-auto flex flex-col items-center xsm:space-y-2  md:space-y-8 text-center">
                            <h1 className="text-white font-bold text-[1.1rem] xsm:mt-10 md:leading-[3.75rem]">
                                Some Numbers That Matter
                            </h1>
                            <p className="text-text_gray-25 font-semibold text-[0.96rem]">
                                Our success is built on trust, reliability, and a commitment to excellence. Here are some key milestones we’ve achieved:
                            </p>
                            <div className="w-[100%] mx-auto flex md:flex-row xsm:flex-col justify-around h-auto min-h-[250px]">
                                {
                                    countData.map((count, index) => (
                                        <motion.div
                                            key={index}
                                            className="w-full xsm:h-[120px] md:h-[250px] relative flex justify-center items-center animate-on-scroll"
                                            initial={{ opacity: 0, scale: 0.9 }}
                                            whileInView={{ opacity: 1, scale: 1 }}
                                            transition={{ duration: 0.5, delay: index * 0.2 }} // Delay for each count item
                                        >
                                            <img src={whitebg} className=" xsm:w-[100px] xsm:h-[110px] md:w-[200px] md:h-[190px]" />
                                            {/* Centering Content */}
                                            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
                                                <h2 className={`text-${count.color} md:text-[1rem] xsm:text-[0.6rem] font-semibold text-[#72AEF4]`}>{count.title}</h2>
                                                <p className="text-[#B6B6B8] text-[0.96rem] leading-[30px]">{count.count}</p>
                                            </div>
                                        </motion.div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </motion.section>
                <section className="w-full flex justify-center items-center xsm:py-10 xsm:h-auto md:h-[600px]">
                    <div className="md:h-[300px] xsm:h-auto xsm:w-[90%] md:w-[85%] lg:w-[80%] flex md:flex-row xsm:flex-col xsm:space-y-4 xsm:justify-between md:justify-between">
                        {/* Left Section */}
                        <motion.div
                            className="flex flex-col items-start md:space-y-4 xsm:space-y-2 md:w-[45%] lg:w-[50%] xsm:w-[100%]"
                            initial={{ opacity: 0, x: -50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.7, delay: 0.1 }}
                        >
                            <motion.p className="text-blue-600 uppercase font-semibold">Testimonials</motion.p>
                            <motion.h2 className="font-bold text-gray-800 xsm:text-[1.3rem] md:text-[1.8rem] lg:text-[2.0rem]">
                                What Our Customers Say
                            </motion.h2>
                            <motion.div className="flex space-x-4 mt-4">
                                <button
                                    onClick={handlePrev}
                                    className="p-2 border border-blue-600 rounded-full text-blue-600 hover:bg-blue-600 hover:text-white transition"
                                >
                                    ←
                                </button>
                                <button
                                    onClick={handleNext}
                                    className="p-2 border border-blue-600 rounded-full text-blue-600 hover:bg-blue-600 hover:text-white transition"
                                >
                                    →
                                </button>
                            </motion.div>
                        </motion.div>

                        {/* Testimonial Card */}
                        <motion.div
                            className="relative md:w-[500px] xsm:w-[100%] md:h-[358px] xsm:h-auto bg-white rounded-[30px] shadow-xl pt-5 md:px-10"
                            initial={{ opacity: 0, x: 50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                        >
                            <motion.div className="rounded-lg p-5 flex flex-col justify-around">
                                <div className="text-gray-700 flex flex-col mb-4">
                                    <p>{title}</p>
                                    <span className="text-yellow-500 font-bold text-2xl">“</span>
                                    <p className="font-poppins text-[19.4px] leading-[29.1px]">{review}</p>
                                </div>
                                <div className="flex items-center justify-between mt-4 border-t-[1px] border-[#D4d4d4] space-x-3 pt-5">
                                    <img src="https://via.placeholder.com/40" alt="User Avatar" className="rounded-full w-[50px]" />
                                    <p className="font-poppins text-[19.4px] font-semibold">{name}</p>
                                    <div className="flex text-yellow-500">
                                        <span>⭐️⭐️⭐️⭐️⭐️</span>
                                    </div>
                                </div>
                            </motion.div>
                        </motion.div>
                    </div>
                </section>
                <section className='w-full xsm:mb-10 '>
                    <div className="w-[70%] mx-auto flex flex-col justify-center items-center h-[500px] xsm:mt-20 md:mt-10">
                        <h2 className="text-[2.5rem] leading-[48px] font-semibold text-[#373937] mb-4 text-center">
                            Get in Touch
                        </h2>

                        <InquiryForm />
                    </div>
                </section>

                <div className='bg-[#0B0757] pb-10'>
                    <Footer />
                </div>

            </div>

            {
                showInquiryForm && (
                    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex flex-col justify-center items-center z-50">
                        <div className="bg-white  rounded-lg relative w-11/12 md:w-1/2">
                            <div className='h-[65px]  bg-newGreen-50 rounded-t-lg   '>
                                <h1 className="text-center md:text-[1.5rem] mb-2 py-3 text-white font-bold  xsm:text-[0.8rem] font-poppins"> Become a Partner</h1>
                                <button
                                    onClick={closeInquiryForm}
                                    className="absolute top-2 right-2 text-white hover:text-gray-50"
                                >
                                    <FaTimes className="text-2xl" />
                                </button>
                            </div>
                            <div className="p-4">
                                <InquiryForm />
                            </div>
                        </div>
                    </div>
                )
            }
        </ >

    );
};

export default Homepage;
